import { useCustomMutation } from '@refinedev/core';

export const useResendInvite = () => {
  const { mutateAsync, isLoading, isSuccess, isError, error } = useCustomMutation();

  const resendInvite = async (userId: string) => {
    mutateAsync({
      method: 'post',
      url: `users/${userId}/resend-invite`,
      values: {},
    });
  };

  return {
    resendInvite,
    isLoading,
    isSuccess,
    isError,
    error,
  };
};
